import React, { Component } from 'react'
import face1 from '../../../assets/images/profile-2.webp'
import { ReactComponent as Logo} from '../../../assets/images/logo-icon.svg'
import logo_color from '../../../assets/images/genhaven-color.webp'
import  agent from '../../../assets/images/agent.svg'
import { ReactComponent as Lockaccess} from '../../../assets/images/lock-access.svg'
import { ReactComponent as Radiocircle}  from '../../../assets/images/radio-circle.svg'
import { ReactComponent as List} from '../../../assets/images/list.svg'
import { ReactComponent as Buildingcommunity}  from '../../../assets/images/building-community.svg'
import { ReactComponent as Person} from '../../../assets/images/person.svg'
import { ReactComponent as Rental} from '../../../assets/images/rental.svg'
import { ReactComponent as MenuList}  from '../../../assets/images/three-dots-vertical.svg'

import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import { Tooltip } from 'reactstrap';
import { APIURL, BASEURL } from '../../../components/constants/common';

export default class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // stylePath:true,
            sidebarClass: "sidebar-icon-only",
            token: JSON.parse(localStorage.getItem("token")),
            user: JSON.parse(localStorage.getItem("userData")),
            profile_image: "",
            dashboard: false,
            myProfile: false,
            property: false,
            enquiry: false,
            agentreq: false,
            changePass: false,
            reload:false,
            NoImage:false,
            mobileView: false
            // user:false
        }
    }

     
   

    getProfileInfo() {
        if (this.state.user) {
            const formData = new FormData();
            formData.append('id', this.state.user.id);
            var token = this.state.token
            var app_url = APIURL+"seller/edit-profile"
            axios
                .post(app_url, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((response) => {
                    const info = response.data.data;
                    this.setState({
                        profile_image: response.data.data.url_path,
                        name: response.data.data.name,
                        NoImage:true
                    })
                })
                .catch((error) => {
                    this.setState({
                        // errMsg: error.response.data.errors,
                        Loader: false
                    })
                });
        }
    }

    dashboard = () => { this.setState({ dashboard: !this.state.dashboard }) }
    myProfile = () => { this.setState({ myProfile: !this.state.myProfile }) }
    property = () => { this.setState({ property: !this.state.property }) }
    enquiry = () => { this.setState({ enquiry: !this.state.enquiry }) }
    agentreq = () => { this.setState({ agentreq: !this.state.agentreq }) }
    changePass = () => { this.setState({ changePass: !this.state.changePass }) }

    componentDidMount() {
        this.getProfileInfo()
    }

    goToHome(){
        window.location.href="/";
    }

    toggleView() {
		this.setState({
			mobileView: !this.state.mobileView
		})
	}

    render() {
        const { user, name } = this.state
        if (!this.state.user) {
            return <Redirect to="/signin" />;
        }
        if (this.state.user.user_type !== "Agent") {
            return <Redirect to="/permission" />;
        }

        console.log(this.props.data);
        
        return (
            <>
                <div className={this.state.mobileView ? "sidebar_alpha open" : "sidebar_alpha"}></div>
                <div className='more-menu' onClick={()=>this.toggleView()}><MenuList class="img-svg" alt="menu-list"/></div>
                <div className={this.state.mobileView ? "admin-sidebar sidebar_mobile open" : "admin-sidebar sidebar_mobile"}>
                    <div class="brand-logo">
                        <a href="#">
                            {/* <Logo onClick={() =>this.goToHome()} class="img-svg" alt="logo" /> */}
                            <img src={logo_color} alt="genhaven logo" class="img-svg"/>
                        </a>
                    </div>

                    <div class="content">
                        <div>
                            <a href="#" class="d-block">
                                <div class="navprofile d-flex align-items-center">
                                    <div class="navprofile__img">
                                    <span> 
                                    {
                                        this.state.NoImage && this.props.data !== undefined && this.props.data.profile_image !== ""
                                        ? <img src={this.props.data.profile_image} alt="profile" />
                                        : this.state.NoImage && <img src={this.state.profile_image !== "" ? this.state.profile_image : agent} alt="profile" />
                                    }
                                    </span>
                                      
                                    </div>
                                    <div>
                                        <div class="navprofile__text ms-3">
                                            <h6 class="font-weight-bold mb-0">{name}</h6>
                                            <span class="text-muted text-small">Agent Panel</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="mt-4">
                            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                                {/* <li class="nav-item">
                                  <Link  className={this.props.activePage === "dashboard" ? "nav-link active" : "nav-link"} to="/agent">
                                  <Gearwide class="img-svg" /><span><span class="ms-3">Dashboard</span></span>
                                  </Link>
                                </li> */}
                                <li class="nav-item">
                                  <Link  className={this.props.activePage === "profile" ? "nav-link active" : "nav-link"} to="/agent">
                                  <Person class="img-svg" /><span><span class="ms-3">My Profile</span></span>
                                  </Link>
                                </li>
                                {/* <li class="nav-item">
                                    <Link className={this.props.activePage === "profile1" ? "nav-link active" : "nav-link"}  class="nav-link" to="/agent/property">
                                    <Buildingcommunity class="img-svg" /><span><span class="ms-3">Property</span></span>
                                    </Link>
                                </li> */}
                                
                                {/* <li class="nav-item">
                                    <Link className={this.props.activePage === "subscribe" ? "nav-link active" : "nav-link"}  class="nav-link" to="/agent/subscribe">
                                    <Radiocircle class="img-svg" /><span><span class="ms-3">Subscribe</span></span>
                                    </Link>
                                </li> */}
                                <li class="nav-item">
                                    <h5 className='mt-3'>Assigned Properties</h5>
                                    <ul className='ms-4'>
                                        <li class="nav-item">
                                            <Link  className={this.props.activePage === "property" ? "nav-link active" : "nav-link"} to="/agent/property">
                                            <Buildingcommunity class="img-svg" /><span><span class="ms-3">Seller</span></span>
                                            </Link>
                                        </li>
                                        <li class="nav-item">
                                            <Link  className={this.props.activePage === "buyerproperty" ? "nav-link active" : "nav-link"} to="/agent/buyerproperty">
                                            <Rental class="img-svg" /><span><span class="ms-3">Buyer</span></span>
                                            </Link>
                                        </li>
                                        <li class="nav-item">
                                            <Link  className={this.props.activePage === "buyeraddedproperty" ? "nav-link active" : "nav-link"} to="/agent/buyeraddedproperty">
                                            <List class="img-svg" /><span><span class="ms-3">Buyer Added</span></span>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                     <Link  className={this.props.activePage === "change_password" ? "nav-link active" : "nav-link"} to="/agent/change-password">
                                     <Lockaccess class="img-svg" /><span><span class="ms-3">Change Password</span></span>
                                     </Link>
                                </li>                               
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
